export const SET_FETCHING = "RECENT_VIEW/SET_FETCHING";
export const LOAD_SEARCH = "RECENT_VIEW/LOAD_SEARCH";
